import {
  DialogModalDS,
  DriverSuccessPage,
  Progressbar,
  ToastContainerDS,
} from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TransactionPage } from "../transactions/transactionPage";
import { ErrorPage } from "../components/ErrorPage";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { selectUploadSupportingDocumentFromBackStatus } from "./uploadSupportingDocumentSlice";
import { useEffect, useState } from "react";
import { selectTransactionData } from "../transactions/transactionDataFormSlice";
import { getCurrentTransactionFormatted } from "../transactions/transactionPageSlice";
import { AxiosProgressEvent } from "axios";
import "../../i18n/i18n";
import { UploadSupportingDocumentMenuOptions } from "./lib/uploadSupportingDocumentMenuOptions";

export const UploadSupportingDocument = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [uploadEventInfo, setUploadEventInfo] = useState<AxiosProgressEvent>();

  const [queryParameters] = useSearchParams();
  const [isExpenseCompleted, setIsExpenseCompleted] = useState<boolean>(false);
  const transactionId = queryParameters.get("id");
  const navigate = useNavigate();

  const uploadSupportingDocumentFromBackStatus = useAppSelector(
    selectUploadSupportingDocumentFromBackStatus,
  );
  const transactionData = useAppSelector(selectTransactionData);
  const currentTransaction = useAppSelector(getCurrentTransactionFormatted);

  useEffect(() => {
    if (
      ["success", "error"].includes(uploadSupportingDocumentFromBackStatus) &&
      transactionId
    )
      if (
        transactionData.isFuelExpense &&
        !transactionData.mileage &&
        transactionData.isMileageMandatory
      ) {
        navigate(`/fuel_data_form?id=${transactionId}`);
      } else {
        setIsExpenseCompleted(true);
      }
  }, [
    dispatch,
    navigate,
    transactionData.isFuelExpense,
    transactionData.isMileageMandatory,
    transactionData.mileage,
    transactionId,
    uploadSupportingDocumentFromBackStatus,
  ]);

  if (transactionId === null) {
    return <ErrorPage />;
  }

  if (isExpenseCompleted) {
    return (
      <DriverSuccessPage
        title={t("success.expense.title")}
        subTitle={t("success.expense.subTitle")}
      />
    );
  }
  if (uploadSupportingDocumentFromBackStatus === "processing") {
    return (
      <DialogModalDS
        visible={
          !!uploadEventInfo?.progress &&
          uploadEventInfo.progress > 0 &&
          uploadEventInfo.progress < 1
        }
        onClose={() => window.location.reload()}
        title={t("supportingDocument.upload.loading")}
      >
        <Progressbar
          percentage={(uploadEventInfo?.progress ?? 0) * 100}
          showLabel
        />
      </DialogModalDS>
    );
  }

  return (
    <TransactionPage toaster={<ToastContainerDS />}>
      <UploadSupportingDocumentMenuOptions
        isPendingAdjustment={
          currentTransaction?.status === "PENDING_ADJUSTEMENT"
        }
        transactionId={transactionId}
        setUploadEventInfo={setUploadEventInfo}
      />
    </TransactionPage>
  );
};
